import { NgModule } from '@angular/core';
import { EntryComponent } from './entry.components';
import { LoginComponent } from './login/login.component';
import { MessageComponent } from './message/message.component';
import { InvitedComponent } from './invited/invited.component';
import { routing } from './entry.route';
import { ForgotPWComponent } from './forgotpw/forgotpw.component';
import { ExistingAccountComponent } from './existing-account/existing-account.component';
import { ResetPWComponent } from './reset-password/reset-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { LoginUserComponent } from './login-user/login-user.component';
import { FirstLoginComponent } from './first-login/first-login.component';
import { FirstLoginFormComponent } from './first-login-form/first-login-form.component';
import { SelfEnrollmentRegistrationComponent } from './self-enrollment/self-enrollment-registration.component';
import { AlreadyLoggedGuardService } from 'directives/already-logged.guard';
import { TermsAndConditionsModule } from 'pages/static-pages/term-and-conditions/terms-and-conditions.module';
import { HeaderModule } from 'components/header/header.module';
import { CheckboxModule, MultiSelectModule, SelectModule } from '@certemy/ui-components';
import { FirstLoginResolverService } from './first-login/first-login-resolver.service';
import { LogoutComponent } from 'pages/entry/logout/logout.components';
import { SelfEnrollmentsService } from 'services/self-enrollments/self-enrollments.service';
import { SelfEnrollmentFirstLoginComponent } from './self-enrollment-first-login/self-enrollment-first-login.component';
import { LoginFormComponent } from 'pages/entry/login-form/login-form.component';
import { SelfEnrollmentLoginComponent } from 'pages/entry/self-enrollment-login/self-enrollment-login.component';
import { SelfEnrollmentFirstLoginResolverService } from './self-enrollment-first-login/self-enrollment-first-login.resolver';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SelfEnrollmentFirstLoginGuardService } from 'pages/entry/self-enrollment-first-login/self-enrollment-first-login.guard';
import { MemberSuiteLoginComponent } from 'pages/entry/member-suite-login/member-suite-login.component';
import { MemberClicksLoginComponent } from 'pages/entry/member-clicks-login/member-clicks-login.component';
import { ChangeEmailComponent } from 'pages/entry/change-email/change-email.component';
import { InviteLocationBlockComponent } from 'pages/entry/location-block/invite-location-block.component';
import { IframeExternalLoginModule } from 'components/iframe-external-login/iframe-external-login.module';
import { RegisterAsModule } from 'components/register-as/register-as.module';
import { ExternalServicesIconsModule } from 'components/external-services-icons/external-services-icons.module';
import { PopupCorporateWebsiteModule } from 'components/popup-corporate-website/popup-corporate-website.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CertemyCommonModule,
    TermsAndConditionsModule,
    HeaderModule,
    MultiSelectModule,
    SelectModule,
    InlineErrorModule,
    NgbModalModule,
    RouterModule.forChild(routing),
    CheckboxModule,
    IframeExternalLoginModule,
    RegisterAsModule,
    ExternalServicesIconsModule,
    PopupCorporateWebsiteModule,
  ],
  declarations: [
    EntryComponent,
    LoginComponent,
    ResetPWComponent,
    MessageComponent,
    VerifyEmailComponent,
    LoginUserComponent,
    ExistingAccountComponent,
    InvitedComponent,
    ForgotPWComponent,
    // RegisterAsComponent,
    FirstLoginComponent,
    FirstLoginFormComponent,
    SelfEnrollmentRegistrationComponent,
    LogoutComponent,
    SelfEnrollmentFirstLoginComponent,
    LoginFormComponent,
    SelfEnrollmentLoginComponent,
    MemberSuiteLoginComponent,
    MemberClicksLoginComponent,
    ChangeEmailComponent,
    InviteLocationBlockComponent,
  ],
  providers: [
    AlreadyLoggedGuardService,
    FirstLoginResolverService,
    SelfEnrollmentsService,
    SelfEnrollmentFirstLoginResolverService,
    SelfEnrollmentFirstLoginGuardService,
  ],
})
export class EntryModule {}
